import { render, staticRenderFns } from "./WindLoadCalculatorPage.vue?vue&type=template&id=5733f3ce&"
import script from "./WindLoadCalculatorPage.vue?vue&type=script&lang=js&"
export * from "./WindLoadCalculatorPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports